import { render } from "./Towers.vue?vue&type=template&id=ada90352&scoped=true"
import script from "./Towers.vue?vue&type=script&lang=js"
export * from "./Towers.vue?vue&type=script&lang=js"

import "./Towers.vue?vue&type=style&index=0&id=ada90352&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ada90352"

export default script